export const getCookie = cookieName => {
  const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));
  return match ? match[1] : undefined;
};
//# sourceMappingURL=cookies.js.map